import { render, staticRenderFns } from "./ErrorReportList.vue?vue&type=template&id=539d91a2&"
import script from "./ErrorReportList.vue?vue&type=script&lang=js&"
export * from "./ErrorReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports